import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const INVOICE_REPORT_MULTIPLE_SORT_BY_DATETIME_FLAG_KEY =
  'invoice-report-multiple-sort-by-datetime' as const;

/**
 * Controls whether the invoice report date columns (Application/Approval/
 * Accounting) show date + time instead of date only. Centralized so the
 * list/admin/approving screens stay in sync.
 */
export const useInvoiceReportMultipleSortByDatetimeFlag = (): boolean =>
  useBooleanFlagValue(INVOICE_REPORT_MULTIPLE_SORT_BY_DATETIME_FLAG_KEY, false);
